<template>
  <div>
    <v-dialog v-model="memberLevelDialog" max-width="400">
      <v-card>
        <v-card-title class="pt-5 pl-5 pb-1 font-weight-bold"
          >자동 변경 제외 회원등급 설정</v-card-title
        >

        <v-card-text class="pl-5">
          <p class="mb-0">
            선택한 회원등급은 정품 인증시 자동 변경하지 않습니다.
          </p>
        </v-card-text>

        <div class="pl-5">
          <div
            v-for="memberLevel in memberLevelItems"
            :key="memberLevel.group_no"
            class="d-flex align-center"
          >
            <div
              v-if="memberLevel.group_no != parent_group_no"
              class="d-flex mt-2 mb-3"
            >
              <v-checkbox
                v-model="memberLevelModal"
                color="primary"
                :value="memberLevel.group_no"
                hide-details
                class="mt-0 pt-0"
              ></v-checkbox>
              <p class="mb-0">
                {{ memberLevel.group_name }}
              </p>
            </div>
          </div>
        </div>

        <v-btn
          color="black"
          hide-details
          depressed
          class="white--text ml-5"
          @click="memberLevelDialog = false"
          width="176"
          >닫기</v-btn
        >

        <v-btn
          color="primary"
          hide-details
          class="white--text ml-2 mt-5 mb-5 pl-4 pr-4 mr-5"
          depressed
          @click="save()"
          width="176"
          >설정</v-btn
        >
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";

export default {
  data: () => {
    return {
      memberLevelDialog: false,
      memberLevelItems: [{ group_name: "", group_no: "" }],
      memberLevelModal: [],
      memberLevelCheckedParams: [],
      parent_index: null,
      parent_group_no: null,
    };
  },
  methods: {
    reset: function() {
      Object.assign(this.$data, this.$options.data());
    },
    show: async function(params, index) {
      console.log("params", params);
      this.reset();
      if (
        params &&
        params.group_exception_list &&
        params.group_exception_list.length > 0
      ) {
        for (const exception of params.group_exception_list) {
          this.memberLevelModal.push(exception.group_no);
        }
      }
      this.parent_index = index;
      this.parent_group_no = params.group_no;
      await this.searchLevel();
    },
    save: async function() {
      this.memberLevelCheckedParams = [];
      if (this.memberLevelModal.length < 1) {
        alert("회원등급을 선택해주세요.");
        return false;
      }

      for (let i = 0; i < this.memberLevelModal.length; i++) {
        let info = this.memberLevelItems.find(
          (item) => item.group_no === this.memberLevelModal[i]
        );
        if (info) {
          this.memberLevelCheckedParams.push(info);
        }
      }

      this.$parent.setGroupExceptionList(
        this.memberLevelCheckedParams,
        this.parent_index
      );
      this.memberLevelDialog = false;
      alert("설정되었습니다.");
    },
    //리스트 조회
    searchLevel: async function() {
      try {
        let result = await M.api(M.entry("/get/groups/list"));
        this.memberLevelItems = result;
        this.memberLevelDialog = true;
      } catch (e) {
        alert("조회되지 않았습니다.");
        this.memberLevelItems = [
          {
            group_no: "1",
            group_name: "일반회원",
          },
          {
            group_no: "10",
            group_name: "라울-1회결제-등급",
          },
        ];
        this.memberLevelDialog = true;

        // this.memberLevelDialog = false;
      }
    },
  },
  mixins: [CommonMixin],
  created: async function() {
    // await this.getGroup();
  },
};
</script>
